webpackJsonp([155849247502049],{

/***/ 4053:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStar = function FaStar(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.6 14.4q0 0.5-0.5 1.1l-8.1 7.9 1.9 11.2q0 0.1 0 0.4 0 0.5-0.2 0.8t-0.7 0.3q-0.4 0-0.9-0.2l-10-5.3-10 5.3q-0.5 0.2-0.9 0.2-0.5 0-0.7-0.3t-0.3-0.8q0-0.1 0.1-0.4l1.9-11.2-8.1-7.9q-0.6-0.6-0.6-1.1 0-0.8 1.3-1l11.2-1.6 5-10.2q0.4-0.9 1.1-0.9t1.1 0.9l5 10.2 11.2 1.6q1.2 0.2 1.2 1z' })
	        )
	    );
	};
	
	exports.default = FaStar;
	module.exports = exports['default'];

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _star = __webpack_require__(4053);
	
	var _star2 = _interopRequireDefault(_star);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles() {
	  return {
	    root: {
	      display: 'inline-block',
	      color: '#dbc70d',
	      '& > svg': {
	        position: 'relative',
	        top: -1
	      }
	    },
	    star: {
	      position: 'relative',
	      top: -1
	    }
	  };
	};
	
	var Featured = function Featured(_ref) {
	  var classes = _ref.classes,
	      doubleStar = _ref.doubleStar,
	      variant = _ref.variant,
	      noIndent = _ref.noIndent,
	      className = _ref.className,
	      starClassName = _ref.starClassName,
	      color = _ref.color,
	      icon = _ref.icon,
	      iconColor = _ref.iconColor,
	      style = _ref.style,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['classes', 'doubleStar', 'variant', 'noIndent', 'className', 'starClassName', 'color', 'icon', 'iconColor', 'style', 'children']);
	
	  return _react2.default.createElement(
	    _Typography2.default,
	    _extends({
	      className: (0, _classnames2.default)(classes.root, className),
	      variant: variant || 'caption',
	      style: _extends({ color: color }, style)
	    }, props),
	    noIndent ? null : _react2.default.createElement(
	      _react.Fragment,
	      null,
	      '\xA0'
	    ),
	    icon ? _react2.default.createElement(
	      _react.Fragment,
	      null,
	      icon,
	      ' ',
	      children || 'Featured',
	      ' ',
	      doubleStar && icon
	    ) : _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_star2.default, {
	        className: (0, _classnames2.default)(classes.star, starClassName),
	        style: { color: iconColor }
	      }),
	      ' ',
	      children || 'Featured',
	      doubleStar && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        ' ',
	        _react2.default.createElement(_star2.default, {
	          className: (0, _classnames2.default)(classes.star, starClassName),
	          style: { color: iconColor }
	        })
	      )
	    )
	  );
	};
	
	Featured.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  variant: _propTypes2.default.string,
	  noIndent: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  starClassName: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  icon: _propTypes2.default.any,
	  iconColor: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.any
	};
	
	exports.default = (0, _withStyles2.default)(styles)(Featured);
	module.exports = exports['default'];

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Meta = __webpack_require__(48);
	
	var _Divider = __webpack_require__(212);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Tags = __webpack_require__(287);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _ShareBar = __webpack_require__(368);
	
	var _ShareBar2 = _interopRequireDefault(_ShareBar);
	
	var _Featured = __webpack_require__(917);
	
	var _Featured2 = _interopRequireDefault(_Featured);
	
	var _theme = __webpack_require__(213);
	
	var _formatDate = __webpack_require__(133);
	
	var _formatDate2 = _interopRequireDefault(_formatDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _extends2, _thumbnail, _title, _featured, _authorWrapper, _dateReadTime, _permissionMessage, _paginateButton;
	
	  return {
	    content: _extends({}, (0, _theme.pageStyle)(theme), (_extends2 = {
	      margin: 0,
	      padding: 10,
	      width: 700
	    }, _extends2[theme.breakpoints.down('sm')] = {
	      width: '90%'
	    }, _extends2)),
	    thumbnail: (_thumbnail = {
	      width: '100%',
	      height: 430,
	      objectFit: 'cover'
	    }, _thumbnail[theme.breakpoints.down('sm')] = {
	      height: '100%'
	    }, _thumbnail),
	    title: (_title = {
	      textTransform: 'none',
	      fontWeight: 600,
	      color: theme.palette.primary.main,
	      padding: 10
	    }, _title[theme.breakpoints.down('xs')] = {
	      fontSize: '1.4em'
	    }, _title),
	    featured: (_featured = {
	      display: 'block',
	      textAlign: 'center',
	      color: theme.palette.featured.onWhiteStrong,
	      fontWeight: 500
	    }, _featured[theme.breakpoints.down('xs')] = {
	      fontSize: '1.1em'
	    }, _featured),
	    authorWrapper: (_authorWrapper = {
	      color: theme.palette.text.soft
	    }, _authorWrapper[theme.breakpoints.down('xs')] = {
	      fontSize: '1em'
	    }, _authorWrapper),
	    author: {
	      fontWeight: 500,
	      color: theme.palette.featured.onWhite,
	      '&:hover': {
	        opacity: 1
	      }
	    },
	    storyFrom: {
	      fontWeight: 500,
	      color: theme.palette.featured.onWhite,
	      '&:hover': {
	        opacity: 1
	      }
	    },
	    dateReadTime: (_dateReadTime = {
	      textAlign: 'center',
	      paddingBottom: 10,
	      color: theme.palette.text.soft
	    }, _dateReadTime[theme.breakpoints.down('xs')] = {
	      fontSize: '1em'
	    }, _dateReadTime),
	    permissionMessage: (_permissionMessage = {
	      textAlign: 'center',
	      fontSize: '0.8em',
	      color: theme.palette.accent.notice
	    }, _permissionMessage[theme.breakpoints.down('xs')] = {
	      marginTop: 10
	    }, _permissionMessage['&:hover'] = {
	      opacity: 1
	    }, _permissionMessage),
	    paginateButton: (_paginateButton = {
	      textTransform: 'none',
	      background: theme.palette.primary.dark,
	      transition: 'color 0.5s, background 0.5s',
	      color: '#fff',
	      margin: '0 ' + theme.spacing.unit + 'px',
	      padding: 'auto 25px',
	      borderRadius: theme.spacing.unit * 5,
	      boxShadow: 'none',
	      '&:hover': {
	        color: theme.palette.primary.dark,
	        background: theme.palette.borders.ghost
	      }
	    }, _paginateButton[theme.breakpoints.down('xs')] = {
	      width: '100%',
	      fontSize: '0.8em'
	    }, _paginateButton),
	    tagsContainer: {
	      minHeight: 35,
	      textAlign: 'center'
	    }
	  };
	};
	
	var StoryTemplate = function StoryTemplate(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      data = _ref.data,
	      pathContext = _ref.pathContext;
	  var previousPage = pathContext.previousPage,
	      nextPage = pathContext.nextPage,
	      storyBody = pathContext.storyBody;
	  var post = data.markdownRemark,
	      file = data.file;
	
	  var baseUrl = 'https://healthfulinspired.com';
	
	  var datePublished = new Date(post.frontmatter.date).toISOString();
	  var dateModified = file.modifiedTime;
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    {
	      id: 'storyPage',
	      spacing: 24,
	      justify: 'center',
	      alignItems: 'center',
	      style: { padding: '20px 0' },
	      container: true
	    },
	    _react2.default.createElement(_Meta.ArticleMeta, {
	      title: post.frontmatter.title,
	      shortDescription: post.frontmatter.shortDescription,
	      thumbnail: post.frontmatter.thumbnail,
	      genre: 'health',
	      tags: post.frontmatter.tags,
	      wordCount: post.wordCount.words,
	      datePublished: datePublished,
	      dateModified: dateModified,
	      articleBody: storyBody,
	      excerpt: post.excerpt,
	      path: post.fields.slug
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { className: classes.content, item: true },
	      _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'display1', align: 'center', className: classes.title },
	        post.frontmatter.title
	      ),
	      post.frontmatter.featured && _react2.default.createElement(
	        _Featured2.default,
	        {
	          variant: 'subheading',
	          className: classes.featured,
	          doubleStar: true
	        },
	        'This story was featured'
	      ),
	      post.frontmatter.displayAuthor && post.frontmatter.author && _react2.default.createElement(
	        _Typography2.default,
	        { align: 'center', className: classes.authorWrapper },
	        'Author:',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: classes.author },
	          post.frontmatter.author
	        ),
	        post.frontmatter.storyFrom && post.frontmatter.storyFrom.toLowerCase() !== post.frontmatter.author.toLowerCase() && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          ' ',
	          'as told by',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: classes.storyFrom },
	            post.frontmatter.storyFrom
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { className: classes.dateReadTime },
	        (0, _formatDate2.default)(post.frontmatter.date),
	        ' ',
	        '\u2022',
	        ' ',
	        post.timeToRead,
	        ' min read'
	      ),
	      _react2.default.createElement('img', {
	        className: classes.thumbnail,
	        src: post.frontmatter.thumbnail,
	        alt: post.frontmatter.title,
	        title: post.frontmatter.title
	      }),
	      _react2.default.createElement(_ShareBar2.default, {
	        baseUrl: baseUrl,
	        url: '' + baseUrl + post.fields.slug,
	        thumbnail: post.frontmatter.thumbnail,
	        title: post.frontmatter.title,
	        excerpt: post.excerpt,
	        tags: post.frontmatter.tags
	      }),
	      post.frontmatter.permission && _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'caption', className: classes.permissionMessage },
	        'This story was given permission by the author to be featured and presented.',
	        _react2.default.createElement('br', null),
	        ' Follow the link at the end to see the original page.'
	      ),
	      _react2.default.createElement('div', {
	        className: 'markdown',
	        dangerouslySetInnerHTML: { __html: post.html }
	      }),
	      post.frontmatter.displaySource && post.frontmatter.source && _react2.default.createElement(
	        _Typography2.default,
	        {
	          align: 'center',
	          variant: 'body1',
	          style: { padding: '15px 0', textTransform: 'none' }
	        },
	        'This article was originally posted',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: post.frontmatter.source, target: '_blank' },
	          'here'
	        )
	      ),
	      _react2.default.createElement(EnhancedArticleNavigator, {
	        previousPage: previousPage,
	        nextPage: nextPage,
	        className: classes.paginateButton
	      }),
	      _react2.default.createElement(_Divider2.default, { offset: 25 }),
	      _react2.default.createElement(
	        'div',
	        { className: classes.tagsContainer },
	        _react2.default.createElement(
	          _Typography2.default,
	          { variant: 'body2' },
	          'tags: \xA0'
	        ),
	        _react2.default.createElement(_Tags2.default, { tags: post.frontmatter.tags })
	      )
	    ),
	    _react2.default.createElement('script', { async: true, defer: true, src: 'http://www.instagram.com/embed.js' }),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n        .markdown img {\n          width: 100%;\n          max-height: 100vh;\n          object-fit: cover;\n          border: 1px solid ' + theme.palette.borders.cloudier + ';\n        }\n        .markdown {\n          color: ' + theme.palette.text.main + ';\n        }\n        table {\n          border: 1px solid ' + theme.palette.primary.main + ';\n        }\n        table th {\n          background: ' + theme.palette.primary.main + ';\n          color: #fff;\n          padding: 10px;\n        }\n        table td {\n          border: 1px solid ' + theme.palette.borders.cloud + ';\n        }\n        h1, h2, h3, h4, h5, h6 {\n          line-height: 1em;\n        }\n        h1 {\n          padding: 20px 0;\n        }\n        .instagram-media {\n          margin: auto !important;\n        }\n        @media (max-width: 600px) {\n          .markdown h1, h2, h3 {\n            font-size: 1.4em;\n          }\n          .markdown img {\n            height: 100%;\n          }\n        }\n      '
	    )
	  );
	};
	
	StoryTemplate.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.shape({
	    previousPage: _propTypes2.default.string,
	    nextPage: _propTypes2.default.string,
	    storyBody: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	function ArticleNavigator(_ref2) {
	  var previousPage = _ref2.previousPage,
	      nextPage = _ref2.nextPage,
	      className = _ref2.className;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        width: '100%',
	        display: 'flex',
	        justifyContent: 'center'
	      }
	    },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        component: previousPage && _gatsbyLink2.default,
	        to: previousPage,
	        variant: 'flat',
	        size: 'medium',
	        className: className,
	        style: { opacity: !previousPage && 0.35 },
	        disabled: !previousPage
	      },
	      'Previous article'
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        component: nextPage && _gatsbyLink2.default,
	        to: nextPage,
	        variant: 'flat',
	        size: 'medium',
	        className: className,
	        style: { opacity: !nextPage && 0.35 },
	        disabled: !nextPage
	      },
	      'Next article'
	    )
	  );
	}
	
	var EnhancedArticleNavigator = (0, _pure2.default)(ArticleNavigator);
	
	// eslint-disable-next-line
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(StoryTemplate);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-story-js-838745a8e29527ab979d.js